import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalReportsHomePageNav4Route: InvariantJiraRoute = {
	name: 'eoc-global-reports',
	path: '/jira/ops/reports',
	exact: true,
};
